import React from 'react'
import { pluralize } from 'humanize-plus'
import { Button } from '@driftt/tide-core-legacy'

import Toggle from 'components/Toggle'
import ConditionalRender from 'components/shared/ConditionalRender'

import EmailEditCard from '../EmailEditCard'
import Card from '../Card'
import TinyEditor from '../TinyEditor'

import './style.styl'
import { EditSenderLevels } from 'app/modules/playbook/constants'

const DelayPrompt = ({
  isMarketingSequencePlaybook,
  delay,
  first = false,
  onDelayChange,
  onThreadedWithPreviousClick,
  threadedWithPrevious,
}) => (
  <div className="playbook-email-delay drift-form">
    {!isMarketingSequencePlaybook &&
      <div className="playbook-email-delay-thread">
        Thread with previous
        <Toggle
          checked={threadedWithPrevious}
          onClick={onThreadedWithPreviousClick}
          className="playbook-email-delay-thread-toggle"
        />
      </div>
    }
    {isMarketingSequencePlaybook ? `Delay ${first ? 'first' : 'next'} email for ` : 'If no reply after '}
    <input type="number" min={first ? 0 : 1} required value={delay} onChange={onDelayChange} className="small" />
    {pluralize(delay, 'day')}
    {isMarketingSequencePlaybook ? '' : ' then send...'}
  </div>
)

const Email = ({
  index,
  email,
  onDelayChange,
  onDeleteClick,
  isMarketingSequencePlaybook,
  isOutboundSequencePlaybook,
  isLastEmail,
  hideDelay,
  showPersonalization = true,
  onTitleChange,
  narrowHeader,
  onMessageChange,
  actions: { setSenderName, setAuthorId, setEmailOverride, setSequenceIndividualEmailOverride, setSequenceIndividualSenderName, setEmailDelay },
  senderEmailOverride,
  sendFromOverride,
  authorId,
  onHeadlineChange,
  onCardMessageChange,
  dynamicAccountSendAttribute,
  dynamicSenderFormat,
  onSendTestEmailClick,
  sendTestEmailLoading,
  sendTestEmailId,
  id,
  isGoogleScopesPending,
  onThreadedWithPreviousClick,
  showOneClickScheduling,
  editSenderLevel,
}) => {
  const setSequenceSenderName = editSenderLevel === EditSenderLevels.LOCAL ? (name) => setSequenceIndividualSenderName({ data: name, emailId: id }) : setSenderName
  const setSequenceEmailOverride = editSenderLevel === EditSenderLevels.LOCAL ? (email) => setSequenceIndividualEmailOverride({ data: email, emailId: id }) : setEmailOverride
  const cardProps = {
    title: `Email ${index + 1}`,
    description: email.title,
    bannerImageUrl: email.bannerImageUrl,
    onDeleteClick: ((index || !isLastEmail) && onDeleteClick),
    onSequenceBodyChange: onMessageChange,
    onSequenceSubjectChange: onTitleChange,
    narrowHeader,
    headline: email.title,
    onTitleChange,
    body: email.message,
    includeSenderSelect: true,
    emailMessage: email,
    setSenderName: setSequenceSenderName,
    setAuthorId,
    setEmailOverride: setSequenceEmailOverride,
    senderEmailOverride,
    sendFromOverride,
    dynamicAccountSendAttribute,
    dynamicSenderFormat,
    authorId,
    setHeadline: onHeadlineChange,
    setMessage: onCardMessageChange,
    onSendTestEmailClick,
    sendTestLoading: id === sendTestEmailId && sendTestEmailLoading,
    id: id,
    showInlineTestEmail: isMarketingSequencePlaybook,
  }
  return (
    <div className="playbook-email">
      <ConditionalRender condition={!hideDelay}>
        <DelayPrompt
          delay={email.delay}
          first={index === 0}
          onDelayChange={onDelayChange}
          isMarketingSequencePlaybook={isMarketingSequencePlaybook}
          onThreadedWithPreviousClick={onThreadedWithPreviousClick}
          threadedWithPrevious={email.threadedWithPrevious}
        />
      </ConditionalRender>
      {isMarketingSequencePlaybook &&
        <div className="sequence-full-email-message">
          <EmailEditCard {...cardProps} includeSenderSelect={isMarketingSequencePlaybook} />
        </div>
      }
      {!isMarketingSequencePlaybook &&
        <Card {...cardProps} >
          <div className="playbook-email-headline">
            <input
              className={email.threadedWithPrevious ? '' : 'playbook-email-headline-error' }
              placeholder={email.threadedWithPrevious ? email.title : '[No Subject] - Required'}
              value={email.threadedWithPrevious ? '' : email.title}
              onChange={onTitleChange}
              disabled={email.threadedWithPrevious}
            />
            <Button type="tertiary" size="small" disabled={isGoogleScopesPending} onClick={onSendTestEmailClick} loading={id === sendTestEmailId && sendTestEmailLoading}>Send Test Email</Button>
          </div>
          <TinyEditor
            className="playbook-email-message"
            initialContent={email.message}
            onChange={onMessageChange}
            showPersonalization={showPersonalization}
            showOneClickScheduling={showOneClickScheduling}
            isOutboundSequencePlaybook={isOutboundSequencePlaybook}
          />
        </Card>
      }
    </div>
  )
}

export default Email



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/Email/component.js